<template>
	<div>
		<Head v-if="page && page.yoast_meta">
			<Title>StocksToTrade | {{ page?.title.rendered }}</Title>
			<Meta
				name="description"
				content="Transform how you trade. Whether you're a beginner or advanced trader, StocksToTrade is about to become your #1 trading tool moving forward. Pick a plan to start now!"
			/>
			<Meta
				name="og:description"
				content="Transform how you trade. Whether you're a beginner or advanced trader, StocksToTrade is about to become your #1 trading tool moving forward. Pick a plan to start now!"
			/>

			<Link
				:href="current_hostname.slice(0, -1) + '/plans/'"
				rel="canonical"
			/>
			<Meta
				:content="current_hostname.slice(0, -1) + '/plans/'"
				property="og:url"
			/>
			<template
				v-for="(tag, i) in page.yoast_meta"
				:key="i"
			>
				<template v-if="tag.content && !tag.content.startsWith('[vc_row')">
					<Meta
						:property="tag.property"
						:content="
							tag.content.includes(hostname)
								? tag.content.replace(hostname, current_hostname)
								: tag.content
						"
						v-if="tag.property"
					/>
					<Meta
						:name="tag.name"
						:content="tag.content"
						v-else-if="tag.name"
					/>
				</template>
			</template>
		</Head>
		<plans-hero-section />
		<plans-scanner-pitch-section />

		<section class="section-gradient">
			<join-mentorship-section />
			<TestimonialSlider />
		</section>
		<why-choose-section />
		<system-requirements-section-new />
		<system-requirements-section />
		<TestimonialSlider2 />
	</div>
</template>

<script setup>
const page = ref(null);

const { hostname, current_hostname } = useRuntimeConfig().public;
const router = useRoute();

const fetchData = async () => {
	try {
		const data = await $fetch(hostname + "wp-json/wp/v2/pages/1236");
		page.value = data;
	} catch (e) {
		console.log(e);
	}
};

const parseSaswpSchema = (content) => {
	const newContent = content["@graph"].map((item) => {
		item["@id"] = item["@id"].replace(
			hostname + "plans-tcl",
			current_hostname + "plans"
		);
		if (item["@type"] === "WebPage") {
			item.url = item.url.replace(
				hostname + "plans-tcl",
				current_hostname + "plans"
			);
			item.breadcrumb["@id"] = item.breadcrumb["@id"].replace(
				hostname,
				current_hostname
			);
			item.isPartOf["@id"] = item.isPartOf["@id"].replace(
				hostname,
				current_hostname
			);

			item.potentialAction = item.potentialAction.map((j) => {
				const newTarget = j.target[0].replace(hostname, current_hostname);
				return { ...j, target: [newTarget] };
			});
		}
		if (item["@type"] === "BreadcrumbList") {
			item.itemListElement.forEach((element) => {
				if (element.item) {
					element.item = element.item.replace(hostname, current_hostname);
				}
			});
		}
		if (item["@type"] === "WebSite") {
			item.potentialAction = item.potentialAction.map((j) => {
				const target = j.target.urlTemplate.replace(hostname, current_hostname);
				return { ...j, target };
			});

			item.publisher["@id"] = item.publisher["@id"].replace(
				hostname,
				current_hostname
			);

			item.url = item.url.replace(hostname, current_hostname);
		}
		if (item["@type"] === "Organization") {
			item.image["@id"] = item.image["@id"].replace(hostname, current_hostname);
			item.logo["@id"] = item.logo["@id"].replace(hostname, current_hostname);
			item.logo.contentUrl = item.logo.contentUrl.replace(
				"https://contentstt.wpenginepowered.com/",
				hostname
			);
			item.logo.url = item.logo.url.replace(
				"https://contentstt.wpenginepowered.com/",
				hostname
			);

			item.url = item.url.replace(
				hostname + "plans-tcl",
				current_hostname + "plans"
			);
		}

		return item;
	});

	console.log({ newContent });
	return { ...content, "@graph": newContent };
};
onMounted(async () => {
	await fetchData();

	// Create the script element
	const scriptElement = document.createElement("script");
	// Set the source URL of the script

	const schema = parseSaswpSchema(JSON.parse(page.value.yoast_meta[14].content));

	scriptElement.innerHTML = JSON.stringify(schema);
	scriptElement.classList.add(`saswp-schema-markup-output`);
	scriptElement.type = "application/ld+json";
	document.head.appendChild(scriptElement);
});

// Here, you can use the slider mixin as before or refactor it as well if needed
</script>

<style lang="scss" scoped></style>
